import React from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "../../../../deviceParametersStyles.pcss";
var cx = classNames.bind(styles);
export var List = function List(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('device-parameters__list'),
    "data-t-id": "components-List"
  }, data.map(function (element) {
    return /*#__PURE__*/React.createElement("li", {
      className: cx('device-parameters__list-item', 'device-parameters__list-item--compared'),
      key: element.key
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      color: "grey50",
      size: "size6-r",
      tagType: "div"
    }, element.key)), /*#__PURE__*/React.createElement("div", {
      className: cx('device-parameters__compared-item')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size6-r",
      tagType: "div"
    }, element.targetDeviceData), /*#__PURE__*/React.createElement(Text, {
      size: "size6-r",
      tagType: "div"
    }, element.comparedDeviceData)));
  }));
};
List.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.arrayOf(PropTypes.shape({
    comparedDeviceData: PropTypes.string,
    key: PropTypes.string,
    targetDeviceData: PropTypes.string
  }))
} : {};